(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-carousel/assets/javascripts/banner-carousel.js') >= 0) return;  svs.modules.push('/widgets/banner-carousel/assets/javascripts/banner-carousel.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_carousel = svs.widget.banner_carousel || {};
svs.widget.banner_carousel.init = svs.banner_groups.banner_carousel.init;

 })(window);